module.exports = __webpack_public_path__ + "static/media/mobizongshu@2x.d0e6ab58.png";